/* TCH Service - liens des pages legales + 4 realisations de l'accueil */
document.addEventListener('DOMContentLoaded', function () {
  var legal = {
    "Mentions légales": "/pages/mentions-legales",
    "Politique de confidentialité": "/pages/politique-de-confidentialite",
    "CGV": "/pages/conditions-generales-de-vente"
  };
  document.querySelectorAll('.legal a').forEach(function (a) {
    var href = legal[a.textContent.trim()];
    if (href) a.setAttribute('href', href);
  });

  var grid = document.getElementById('wkGrid');
  if (!grid || document.getElementById('filters')) return;
  var base = 'https://cdn.shopify.com/s/files/1/1090/5973/5883/files/';
  var items = [
    ["La Santé", "Boutique en ligne · running et streetwear", "Collections Running et Streetwear, best-sellers, guide des tailles et FAQ.", "lasanteparis.fr", "179FE857-492E-4F5C-9756-B6F8F77C4080.png"],
    ["Winterfellstore", "Boutique en ligne · mode multi-marques", "Un vaste catalogue organisé par marques, avec paiement en plusieurs fois.", "winterfellshop.com", "30C6375A-29B8-459E-80AF-54B219CE8A31.png"],
    ["DS Elite Van", "Site de services · chauffeur privé", "Site sur-mesure pour un service de chauffeur privé haut de gamme.", "dselitevan.com", "DEBF1901-A37C-4D28-AAA3-F9E5B5EF9642.png"],
    ["Dex Recovery", "Boutique en ligne · récupération sportive", "Catalogue d'une marque de récupération musculaire.", "dexrecovery.com", "DE48E216-AF2A-4344-A45F-4FAFD1902FB7.png"]
  ];
  grid.innerHTML = items.map(function (i) {
    return '<article class="wk-card"><div class="wk-media wk-img"><img src="' + base + i[4] + '?width=1000" alt="Site ' + i[0] + ' sur ordinateur et mobile" loading="lazy" width="1624" height="969"></div>' +
      '<div class="wk-body"><span class="wk-cat">' + i[1] + '</span><h3>' + i[0] + '</h3><p>' + i[2] + '</p>' +
      '<a class="wk-link" href="https://' + i[3] + '" target="_blank" rel="noopener">Voir ' + i[3] + '</a></div></article>';
  }).join('');
});
